/* =========================================================
   Ride Depot theme, interactions
   Cart + search wired to Shopify's native AJAX APIs.
   ========================================================= */
(function () {
  'use strict';
  var T = window.theme || {};
  var routes = T.routes || {};

  /* ---------- money ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseInt(cents.replace(/[^0-9-]/g, ''), 10);
    if (isNaN(cents)) return '';
    var fmt = T.moneyFormat || '${{amount}}';
    var value = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var valueNoDec = Math.round(cents / 100).toLocaleString();
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, valueNoDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, valueNoDec);
  }
  window.formatMoney = formatMoney;
  /* discount badge label, mirrors snippets/discount-badge.liquid: saving < $10 -> "XX% off", else "$XX off" */
  function rdDiscLabel(compare, price) {
    var save = (compare || 0) - (price || 0);
    if (save <= 0) return '';
    if (save < 1000) return Math.round(save * 100 / compare) + '% off';
    return formatMoney(save).replace(/\.00$/, '') + ' off';
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    document.getElementById('toastMsg').textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }
  window.toast = toast;

  /* ---------- header scroll ---------- */
  window.addEventListener('scroll', function () {
    var h = document.getElementById('hdr');
    if (h) h.classList.toggle('scrolled', window.scrollY > 10);
  });

  /* ---------- dynamic header height (so logo size never overlaps content) ---------- */
  function rdSetHdrHeight() {
    var h = document.getElementById('hdr');
    if (h) document.documentElement.style.setProperty('--rd-hdr-h', h.offsetHeight + 'px');
  }
  rdSetHdrHeight();
  window.addEventListener('resize', rdSetHdrHeight);
  window.addEventListener('load', rdSetHdrHeight);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(rdSetHdrHeight);
  // re-measure once the logo image has loaded (its height drives the bar)
  (function () {
    var img = document.querySelector('.logo-img');
    if (img && !img.complete) img.addEventListener('load', rdSetHdrHeight);
    setTimeout(rdSetHdrHeight, 300);
  })();

  /* ---------- mega menus ---------- */
  var megaTimer;
  function openMega(id, btn) {
    clearTimeout(megaTimer);
    closeMega();
    var m = document.getElementById('mega-' + id);
    if (m) m.classList.add('open');
    if (btn) btn.classList.add('active');
  }
  function closeMega() {
    document.querySelectorAll('.mega').forEach(function (m) { m.classList.remove('open'); });
    document.querySelectorAll('nav.main button').forEach(function (b) { b.classList.remove('active'); });
  }
  window.closeMega = closeMega;
  document.querySelectorAll('nav.main button[data-mega]').forEach(function (b) {
    b.addEventListener('mouseenter', function () { openMega(b.dataset.mega, b); });
    b.addEventListener('mouseleave', function () { megaTimer = setTimeout(closeMega, 140); });
  });
  document.querySelectorAll('.mega').forEach(function (m) {
    m.addEventListener('mouseenter', function () { clearTimeout(megaTimer); });
  });

  /* ---------- category index ---------- */
  window.setIdx = function (i) {
    document.querySelectorAll('.idx-row').forEach(function (r, n) { r.classList.toggle('act', n === i); });
    document.querySelectorAll('#idxPreview .frame').forEach(function (f, n) { f.classList.toggle('show', n === i); });
  };

  /* ---------- garage (real YMM fitment) ---------- */
  var RD_FIT = null, RD_GARAGE = null;
  function byId(id) { return document.getElementById(id); }
  function loadFit(cb) {
    if (RD_FIT) { cb(RD_FIT); return; }
    if (!window.RD_FITMENT_URL) { cb({}); return; }
    fetch(window.RD_FITMENT_URL).then(function (r) { return r.json(); })
      .then(function (d) { RD_FIT = d; cb(d); }).catch(function () { cb({}); });
  }
  function fillMakes(sel) {
    if (!sel) return;
    loadFit(function (d) {
      var o = '<option value="">Make</option>';
      Object.keys(d).forEach(function (m) { o += '<option' + (RD_GARAGE && RD_GARAGE.make === m ? ' selected' : '') + '>' + m + '</option>'; });
      sel.innerHTML = o;
    });
  }
  window.rdMakeChange = function (mk, md, yr) {
    loadFit(function (d) {
      var make = byId(mk).value, ms = d[make] ? Object.keys(d[make]) : [];
      var o = '<option value="">Model</option>';
      ms.forEach(function (m) { o += '<option>' + m + '</option>'; });
      if (byId(md)) byId(md).innerHTML = o;
      if (byId(yr)) byId(yr).innerHTML = '<option value="">Year</option>';
    });
  };
  window.rdModelChange = function (mk, md, yr) {
    loadFit(function (d) {
      var make = byId(mk).value, model = byId(md).value;
      var r = (d[make] && d[make][model]) ? d[make][model] : null, o = '<option value="">Year</option>';
      if (r) { for (var y = r[1]; y >= r[0]; y--) o += '<option>' + y + '</option>'; }
      if (byId(yr)) byId(yr).innerHTML = o;
    });
  };
  function setGarageFrom(mk, md, yr) {
    var make = (byId(mk) || {}).value, model = (byId(md) || {}).value, year = (byId(yr) || {}).value;
    if (!make) { toast('Pick a make first'); return; }
    RD_GARAGE = { make: make, model: model, year: year, label: ((year ? year + ' ' : '') + make + (model ? ' ' + model : '')).trim() };
    try { localStorage.setItem('rd_garage_v2', JSON.stringify(RD_GARAGE)); } catch (e) {}
    syncGarageChip(); applyFits(); closeGarage();
    toast('Garage set · ' + RD_GARAGE.label);
    window.dispatchEvent(new Event('rd:garage-changed'));
  }
  window.setGarage = function () { setGarageFrom('selMake', 'selModel', 'selYear'); };
  window.rdGarageSet = function () { setGarageFrom('gMake', 'gModel', 'gYear'); };
  window.rdGarageClear = function () {
    RD_GARAGE = null; try { localStorage.removeItem('rd_garage_v2'); } catch (e) {}
    syncGarageChip(); applyFits(); toast('Garage cleared');
    window.dispatchEvent(new Event('rd:garage-changed'));
  };
  window.rdGetGarage = function () { return RD_GARAGE; };

  /* ---------- open Shopify Inbox chat (best-effort), fallback to contact ---------- */
  window.rdOpenChat = function () {
    // Shopify Inbox renders a <shopify-chat> web component whose launcher lives in a shadow root
    // and loads asynchronously, so poll briefly instead of giving up on the first click.
    function tryOpen() {
      try {
        var host = document.querySelector('#shopify-chat, shopify-chat');
        if (host) {
          // 2026-09-14: Inbox now nests its launcher two shadow roots deep
          // (shopify-chat > shopify-agent-runtime > ... > button.activator), so a one-level
          // shadowRoot.querySelector found nothing and this function silently did nothing,
          // which also killed the "Have a question / Chat now" box. Walk nested shadow roots.
          function deepFind(root, sel, depth) {
            depth = depth || 0; if (!root || depth > 6) return null;
            var hit = root.querySelector && root.querySelector(sel); if (hit) return hit;
            var all = root.querySelectorAll ? root.querySelectorAll('*') : [];
            for (var i = 0; i < all.length; i++) { if (all[i].shadowRoot) { var r = deepFind(all[i].shadowRoot, sel, depth + 1); if (r) return r; } }
            return null;
          }
          var btn = deepFind(host.shadowRoot || host, 'button.activator,[aria-label*="chat" i],button,[role="button"]');
          if (btn) { btn.click(); return true; }
        }
        var bubble = document.querySelector('button[aria-label*="chat" i],[aria-label*="chat with" i],.shopify-chat-button');
        if (bubble) { bubble.click(); return true; }
      } catch (e) {}
      return false;
    }
    if (tryOpen()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (tryOpen() || tries > 24) {
        clearInterval(iv);
        // widget never appeared after ~6s -> fall back to email (never self-redirect, which reloads the contact page)
        if (tries > 24 && !document.querySelector('#shopify-chat, shopify-chat')) { window.location.href = 'mailto:sabri@ridedepot.com'; }
      }
    }, 250);
  };

  /* ---------- PDP image zoom + helmet size guide ---------- */
  window.rdZoom = function () {
    var g = byId('gmain'), o = byId('zoomOverlay'), i = byId('zoomImg');
    if (!g || !o || !i) return;
    i.src = g.src; o.classList.add('open'); document.body.style.overflow = 'hidden';
  };
  window.closeZoom = function () { var o = byId('zoomOverlay'); if (o) o.classList.remove('open'); document.body.style.overflow = ''; };
  window.openSizeGuide = function () { var m = byId('sgModal'), o = byId('sgOverlay'); if (m) m.classList.add('open'); if (o) o.classList.add('open'); };
  window.closeSizeGuide = function () { var m = byId('sgModal'), o = byId('sgOverlay'); if (m) m.classList.remove('open'); if (o) o.classList.remove('open'); };
  window.openApparelSg = function () { var m = byId('asgModal'), o = byId('asgOverlay'); if (m) m.classList.add('open'); if (o) o.classList.add('open'); };
  window.closeApparelSg = function () { var m = byId('asgModal'), o = byId('asgOverlay'); if (m) m.classList.remove('open'); if (o) o.classList.remove('open'); };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeZoom(); closeSizeGuide(); closeGarage(); }
  });

  /* ---------- product card image preview (dots + mobile swipe) ---------- */
  document.querySelectorAll('.card-dots').forEach(function (dots) {
    var vis = dots.closest('.visual');
    var img = vis && vis.querySelector('.pimg');
    if (!img) return;
    var first = img.getAttribute('src');
    var firstSet = img.getAttribute('srcset');
    var ds = [].slice.call(dots.querySelectorAll('.cdot'));
    var idx = 0;
    function activate(n) {
      idx = (n + ds.length) % ds.length;
      var d = ds[idx];
      /* srcset overrides src, with it present the browser keeps painting the original
         image no matter what src is set to (dots moved, picture didn't). Drop it. */
      if (d.dataset.src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = d.dataset.src; }
      ds.forEach(function (x, i) { x.classList.toggle('on', i === idx); });
    }
    ds.forEach(function (dot, i) {
      dot.addEventListener('mouseenter', function () { activate(i); });
      dot.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); activate(i); });
    });
    vis.addEventListener('mouseleave', function () { idx = 0; img.src = first; if (firstSet) img.setAttribute('srcset', firstSet); ds.forEach(function (x, i) { x.classList.toggle('on', i === 0); }); });
    /* Swipe, carousel-style intent detection. Real thumbs always drift a few px
       vertically, so iOS claims the gesture for scrolling and CANCELS our touch/pointer
       events before touchend/pointerup ever fires (synthetic tests pass; real phones fail).
       Fix: watch touchmove, and the moment the gesture is clearly horizontal, call
       preventDefault() (non-passive listener) so the browser never takes it. Vertical
       gestures are released immediately so page scrolling stays native. */
    var sx = null, sy = null, hIntent = false, swiped = false;
    vis.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; hIntent = false;
    }, { passive: true });
    vis.addEventListener('touchmove', function (e) {
      if (sx === null) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (!hIntent) {
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) + 4) hIntent = true;      // ours
        else if (Math.abs(dy) > 10) { sx = null; return; }                            // scroll, let go
      }
      if (hIntent && e.cancelable) e.preventDefault();
    }, { passive: false });
    vis.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (hIntent && Math.abs(dx) > 24) { activate(idx + (dx < 0 ? 1 : -1)); swiped = true; }
      sx = null; hIntent = false;
    }, { passive: true });
    vis.addEventListener('touchcancel', function () { sx = null; hIntent = false; }, { passive: true });
    vis.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; } }, true);
  });

  /* ---------- hero slideshow ---------- */
  (function () {
    var box = document.getElementById('heroSlides'); if (!box) return;
    var slides = [].slice.call(box.querySelectorAll('.herox-slide'));
    if (slides.length < 2) return;
    var i = 0;
    var media = box.closest ? box.closest('.herox-media') : box.parentNode;
    var contents = [].slice.call(document.querySelectorAll('.herox-inner.hc'));
    function applyContent(){
      var t = slides[i].getAttribute('data-content');
      contents.forEach(function(el){ el.hidden = (t && el.id !== t); });
      if (media) media.classList.toggle('herox-banner-on', slides[i].hasAttribute('data-href'));
    }
    applyContent();
    setInterval(function () {
      slides[i].classList.remove('active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('active');
      applyContent();
    }, 6000);
    if (media) media.addEventListener('click', function (e) {
      if (e.target.closest('a,button,select,input,label')) return;
      var active = box.querySelector('.herox-slide.active');
      var href = active && active.getAttribute('data-href');
      if (href) window.location.href = href;
    });
  })();
  function syncGarageChip() {
    var chip = byId('garageChip'), lbl = byId('garageLbl'), cur = byId('gmCurrent'), clr = byId('gmClear');
    if (RD_GARAGE) {
      if (lbl) lbl.textContent = RD_GARAGE.label; if (chip) chip.classList.add('set');
      if (cur) cur.textContent = 'Current bike: ' + RD_GARAGE.label; if (clr) clr.style.display = '';
    } else {
      if (lbl) lbl.textContent = ''; if (chip) chip.classList.remove('set');
      if (cur) cur.textContent = ''; if (clr) clr.style.display = 'none';
    }
  }
  /* helmet stock guarantee popup (2026-09-14). Same overlay/modal classes as the garage. */
  window.openGuarantee = function () {
    var m = byId('guarModal'), o = byId('guarOverlay'); if (!m) return;
    m.classList.add('open'); if (o) o.classList.add('open');
    if (typeof lockBody === 'function') lockBody('guarantee', true); else document.body.style.overflow = 'hidden';
  };
  window.closeGuarantee = function () {
    var m = byId('guarModal'), o = byId('guarOverlay');
    if (m) m.classList.remove('open'); if (o) o.classList.remove('open');
    if (typeof lockBody === 'function') lockBody('guarantee', false); else document.body.style.overflow = '';
  };
  window.openGarage = function () {
    closeMega();
    var m = byId('garageModal'), o = byId('garageOverlay');
    if (!m) { toast('Garage'); return; }
    fillMakes(byId('gMake'));
    if (RD_GARAGE) { setTimeout(function () { if (byId('gMake')) { byId('gMake').value = RD_GARAGE.make; rdMakeChange('gMake', 'gModel', 'gYear'); setTimeout(function () { if (byId('gModel')) byId('gModel').value = RD_GARAGE.model || ''; rdModelChange('gMake', 'gModel', 'gYear'); setTimeout(function () { if (byId('gYear')) byId('gYear').value = RD_GARAGE.year || ''; }, 120); }, 120); } }, 60); }
    m.classList.add('open'); if (o) o.classList.add('open'); lockBody('garage', true);
  };
  window.closeGarage = function () {
    var m = byId('garageModal'), o = byId('garageOverlay');
    if (m) m.classList.remove('open'); if (o) o.classList.remove('open'); lockBody('garage', false);
  };
  function fitsBike(el) {
    if (!RD_GARAGE) return false;
    if (el.getAttribute('data-gear') === 'true') return false; // rider gear (helmets, comms, phone mounts) isn't bike-fitment
    if (el.getAttribute('data-universal') === 'true') return false; // universal fits all; not personally badged
    var f = el.getAttribute('data-fits') || ''; if (!f) return false;
    var arr = f.split(';');
    for (var i = 0; i < arr.length; i++) {
      var p = arr[i].split('|'); if (p.length < 3) continue;
      if (p[0] === RD_GARAGE.make && p[1] === RD_GARAGE.model) {
        if (!RD_GARAGE.year) return true;
        var yr = p[2].split('-'), y = +RD_GARAGE.year;
        if (y >= +yr[0] && y <= +yr[yr.length - 1]) return true;
      }
    }
    return false;
  }
  window.rdFitsBike = fitsBike;
  window.applyFits = function () {
    document.querySelectorAll('.card[data-fits],.card[data-universal]').forEach(function (el) {
      el.classList.toggle('fits', fitsBike(el));
    });
    if (window.rdPdpFit) window.rdPdpFit();
  };
  window.rdPdpFit = function () {
    var el = byId('pdpFit'); if (!el) return;
    if (el.getAttribute('data-gear') === 'true') { el.style.display = 'none'; return; } // rider gear: no fitment widget
    if ((el.getAttribute('data-note') || '').trim()) { el.style.display = 'none'; return; } // curated fitment_note wins, shown by the .fitbox instead of the generic widget
    var uni = el.getAttribute('data-universal') === 'true', hasfit = (el.getAttribute('data-fits') || '') !== '';
    function show(cls, html) { el.style.display = ''; el.className = 'pdp-fit ' + cls; el.innerHTML = html; }
    if (!RD_GARAGE) {
      if (uni) show('neutral', 'Fits most bikes, choose the correct mount or size for yours');
      else if (hasfit) show('neutral', '<span>Check this fits your bike</span><button type="button" onclick="openGarage()">Select your bike</button>');
      else el.style.display = 'none';
      return;
    }
    var lbl = RD_GARAGE.label || 'your bike';
    if (uni) { show('neutral', 'Fits your ' + lbl + ' with the correct mount or size'); return; }
    if (fitsBike(el)) show('ok', '✓ Confirmed fit for your ' + lbl);
    else el.style.display = 'none'; // NEVER warn "may not fit", fitment data is incomplete catalog-wide and a false negative loses the sale (Abi 2026-08-12). Only ever affirm a confirmed fit.
  };
  // legacy hero selector hooks
  window.onMake = function () { rdMakeChange('selMake', 'selModel', 'selYear'); };
  // populate a make/model/year selector trio from the current garage
  function rdFillSelectors(mk, md, yr) {
    if (!RD_GARAGE || !byId(mk)) return;
    byId(mk).value = RD_GARAGE.make; rdMakeChange(mk, md, yr);
    setTimeout(function () {
      if (byId(md)) { byId(md).value = RD_GARAGE.model || ''; rdModelChange(mk, md, yr); }
      setTimeout(function () { if (byId(yr)) byId(yr).value = RD_GARAGE.year || ''; }, 130);
    }, 130);
  }
  window.rdFillSelectors = rdFillSelectors;
  (function rdPreselectStock() {
    if (!window.rdProduct) return;
    // Always reconcile the buy box (stock line, button label, availability) with the
    // actually-selected variant on load, even for products without a shelf-qty map
    // (e.g. helmets with per-variant lead times). Otherwise the server-rendered stock
    // line can stay stale when switching to an out-of-stock variant.
    if (!window.rdStock || !rdPhysStock()) { rdRefresh(); return; }
    if (/[?&]variant=/.test(location.search)) { rdRefresh(); return; } // deep link chooses; just repaint badges
    var cur = rdCurrentVariant();
    var curSt = cur ? vState(cur) : null;
    if (cur && (curSt === 'instock' || curSt === 'low')) { rdRefresh(); return; } // already on a stocked size
    var pick = window.rdProduct.variants.find(function (v) { var s = vState(v); return s === 'instock' || s === 'low'; });
    if (!pick) { rdRefresh(); return; }
    var segs = [].slice.call(document.querySelectorAll('.opt .seg'));
    segs.forEach(function (seg) {
      var idx = parseInt(seg.dataset.optIndex, 10);
      seg.querySelectorAll('button').forEach(function (b) { b.classList.toggle('act', b.dataset.value === pick.options[idx]); });
      var span = document.getElementById(seg.dataset.valspan);
      if (span) span.textContent = pick.options[idx];
    });
    rdRefresh();
  })();
  /* The page opens on the first in-stock variant (Abi 2026-11-01). This replaced rd-no-size-preselect (2026-09-30), which opened with Size empty. */
  (function restoreGarage() {
    try { var g = localStorage.getItem('rd_garage_v2'); if (g) RD_GARAGE = JSON.parse(g); } catch (e) {}
    fillMakes(byId('gMake')); fillMakes(byId('selMake'));
    syncGarageChip(); applyFits();
    if (RD_GARAGE) setTimeout(function () { rdFillSelectors('selMake', 'selModel', 'selYear'); }, 80);
  })();
  // keep the hero fitment bar in sync whenever the garage changes (e.g. set via the top Garage popup)
  window.addEventListener('rd:garage-changed', function () {
    if (RD_GARAGE) rdFillSelectors('selMake', 'selModel', 'selYear');
    else { ['selMake', 'selModel', 'selYear'].forEach(function (id) { if (byId(id)) byId(id).selectedIndex = 0; }); }
  });

  /* ---------- mobile navigation drawer ---------- */
  /* iOS-safe scroll lock: overflow:hidden alone does NOT stop iOS Safari scrolling the page behind
     an overlay. position:fixed + restore scrollY does. Ref-counted by source so stacked overlays are safe. */
  var _rdLocks = {}, _rdScrollY = 0;
  window.lockBody = function (src, on) {
    var b = document.body, k, hadAny = false, nowAny = false;
    for (k in _rdLocks) { if (_rdLocks[k]) { hadAny = true; break; } }
    _rdLocks[src] = !!on;
    for (k in _rdLocks) { if (_rdLocks[k]) { nowAny = true; break; } }
    if (nowAny && !hadAny) {
      _rdScrollY = window.scrollY || window.pageYOffset || 0;
      b.style.position = 'fixed'; b.style.top = (-_rdScrollY) + 'px';
      b.style.left = '0'; b.style.right = '0'; b.style.width = '100%'; b.style.overflow = 'hidden';
    } else if (!nowAny && hadAny) {
      b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = ''; b.style.overflow = '';
      window.scrollTo(0, _rdScrollY);
    }
  };
  window.toggleMobileNav = function (open) {
    var n = document.getElementById('mnav'), o = document.getElementById('mnavOverlay');
    if (!n) return;
    var show = (open === undefined) ? !n.classList.contains('open') : open;
    if (show) closeMega();
    n.classList.toggle('open', show);
    if (o) o.classList.toggle('open', show);
    lockBody('nav', show);
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var n = document.getElementById('mnav');
      if (n && n.classList.contains('open')) toggleMobileNav(false);
    }
  });

  /* ---------- product rail ---------- */
  window.railScroll = function (d) {
    var r = document.getElementById('rail');
    if (r) r.scrollBy({ left: d * 360, behavior: 'smooth' });
  };

  /* ---------- shop-the-build hotspots ---------- */
  window.toggleHs = function (e, btn) {
    e.stopPropagation();
    var hs = btn.closest('.hs');
    var open = hs.classList.contains('open');
    document.querySelectorAll('.hs').forEach(function (h) { h.classList.remove('open'); });
    if (!open) hs.classList.add('open');
  };
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.hs')) document.querySelectorAll('.hs').forEach(function (h) { h.classList.remove('open'); });
  });

  /* ---------- cart (Shopify AJAX) ---------- */
  function cartUrl(suffix) { return (routes.cart_url || '/cart') + suffix; }

  window.addToCart = function (variantId, name, qty) {
    if (!variantId) { toast('Select options first'); return; }
    qty = qty && qty > 0 ? qty : 1;
    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.d.description || 'Could not add to cart'); return; }
        toast('Added · ' + (name || 'item'));
        bumpCount();
        return renderCart().then(function () { if (T.cartDrawer) toggleCart(true); });
      })
      .catch(function () { toast('Network error'); });
  };

  window.changeQty = function (key, qty) {
    fetch(routes.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return renderCart(); })
      .catch(function () { toast('Network error'); });
  };

  function bumpCount() {
    var cc = document.getElementById('cartCount');
    if (!cc) return;
    cc.classList.add('show');
    cc.style.transform = 'scale(1.3)';
    setTimeout(function () { cc.style.transform = 'scale(1)'; }, 180);
  }

  function renderCart() {
    return fetch(cartUrl('.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cc = document.getElementById('cartCount');
        if (cc) { cc.textContent = cart.item_count; cc.classList.toggle('show', cart.item_count > 0); }

        var body = document.getElementById('drawerBody');
        var foot = document.getElementById('drawerFoot');
        if (!body || !foot) return cart;

        if (!cart.items.length) {
          body.innerHTML = '<div class="cart-empty"><div class="big">🏍️</div><p>' + (window.theme.t_cartEmpty || "Your cart is empty.<br>Add parts and they'll show up here.") + '</p></div>';
          foot.innerHTML = '';
          var _xe = document.getElementById('drawerXsell'); if (_xe) _xe.style.display = 'none';
          return cart;
        }
        var _xs = document.getElementById('drawerXsell'); if (_xs) _xs.style.display = '';

        body.innerHTML = cart.items.map(function (it) {
          var img = it.image ? '<img class="timg" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">' : '<span class="tini">' + initials(it.vendor || it.product_title) + '</span>';
          /* line items link back to the product, variant carried (2026-09-14). it.url is Shopify-built
             and already variant-specific; it still goes through escapeHtml because every other value
             in this function does. No url (shouldn't happen) degrades to the old plain divs. */
          var href = it.url ? escapeHtml(it.url) : (it.handle ? '/products/' + encodeURIComponent(it.handle) : '');
          var picTag = href ? 'a class="pic' : 'div class="pic';
          var picEnd = href ? '</a>' : '</div>';
          var title = escapeHtml(it.product_title);
          return '<div class="citem" data-pid="' + it.product_id + '" data-handle="' + escapeHtml(it.handle || '') + '" data-ptype="' + escapeHtml(it.product_type || '') + '">' +
            '<' + picTag + (it.image ? '' : ' noimg') + '"' + (href ? ' href="' + href + '"' : '') + '>' + img + picEnd +
            '<div class="info">' +
            '<div class="t">' + (href ? '<a href="' + href + '">' + title + '</a>' : title) + '</div>' +
            '<div class="s">' + escapeHtml(it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : (it.vendor || '')) + '</div>' +
            '<div class="qty">' +
            '<button onclick="changeQty(\'' + it.key + '\',' + (it.quantity - 1) + ')" aria-label="Decrease">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button onclick="changeQty(\'' + it.key + '\',' + (it.quantity + 1) + ')" aria-label="Increase">+</button>' +
            /* remove = trash icon at the right end of the qty row (Abi 2026-10-10), was a "Remove" text link under it */
            '<button class="citem-trash" onclick="changeQty(\'' + it.key + '\',0)" aria-label="Remove ' + escapeHtml(it.product_title) + '" title="Remove"><svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M9 7V4.8c0-.4.4-.8.8-.8h4.4c.4 0 .8.4.8.8V7"/><path d="M6.5 7l.8 12.2c.1.9.8 1.6 1.7 1.6h6c.9 0 1.6-.7 1.7-1.6L17.5 7"/><path d="M10 11v6M14 11v6"/></svg></button>' +
            '</div>' +
            '</div>' +
            '<div class="pr">' + formatMoney(it.final_line_price) + '</div>' +
            '</div>';
        }).join('');
        shieldUpsell(cart, body);

        var sub = cart.total_price;
        /* Free shipping threshold: $150+ (Abi 2026-10-03; $99 from 2026-09-30, $50 from 2026-08-02) */
        var FREE_SHIP_MIN = (T && T.freeShipThreshold) || 15000;
        var shipRow, progress;
        var pct = Math.max(0, Math.min(100, Math.round(sub / FREE_SHIP_MIN * 100)));
        if (sub >= FREE_SHIP_MIN) {
          shipRow = 'Free';
          progress = '<div class="freeship unlocked"><div class="freeship-msg">✓ Free shipping unlocked</div><div class="freeship-track"><div class="freeship-fill" style="width:100%"></div></div></div>';
        } else {
          shipRow = 'Calculated at checkout';
          progress = '<div class="freeship"><div class="freeship-msg">Add <b>' + formatMoney(FREE_SHIP_MIN - sub) + '</b> more for free shipping</div><div class="freeship-track"><div class="freeship-fill" style="width:' + pct + '%"></div></div></div>';
        }
        foot.innerHTML =
          '<div class="row"><span>Subtotal</span><span>' + formatMoney(sub) + '</span></div>' +
          '<div class="row"><span>Shipping</span><span>' + shipRow + '</span></div>' +
          '<div class="row total"><span>Total</span><span>' + formatMoney(sub) + '</span></div>' +
          progress +
          '<a class="checkout" href="' + (routes.cart_url || '/cart') + '" onclick="this.setAttribute(\'href\',\'/checkout\')">Checkout <svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8"><path d="M5 12h14"/><path d="M13 6l6 6-6 6"/></svg></a>';
        return cart;
      });
  }
  window.renderCart = renderCart;

  /* Cart drawer shield suggestion (Meto 2026-10-10, Abi: "add that on the cart too, right under the
     helmet as a suggestion"). For each helmet line, fetch /products/<handle>?view=cart-upsell
     (templates/product.cart-upsell.liquid), which returns the first shield/visor in that helmet's
     custom.related, or null. Shown right under the helmet line, with a colour picker so we never
     guess a tint for the rider. Skipped when that shield product is already in the cart. */
  var _shieldCache = {};
  function shieldFor(handle) {
    if (!_shieldCache[handle]) {
      _shieldCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=cart-upsell')  /* no Accept: application/json, that makes Shopify return its own product JSON and skip the view */
        .then(function (r) { return r.ok ? r.text() : 'null'; })
        .then(function (t) { try { return JSON.parse(t); } catch (e) { return null; } })
        .catch(function () { return null; });
    }
    return _shieldCache[handle];
  }
  function shieldUpsell(cart, body) {
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var shown = {};
    body.querySelectorAll('.citem[data-ptype="Helmets"]').forEach(function (row) {
      var handle = row.getAttribute('data-handle');
      if (!handle) return;
      shieldFor(handle).then(function (sh) {
        if (!sh || !sh.variants || !sh.variants.length) return;
        if (inCart[sh.product_id] || shown[sh.product_id]) return;
        if (!row.isConnected || (row.nextElementSibling && row.nextElementSibling.classList.contains('cupsell'))) return;
        shown[sh.product_id] = true;
        var many = sh.variants.length > 1;
        /* Dark smoke first in the list and selected (Abi 2026-10-10); the feed spells it Dark Smke W/, Drk Smk,
           Dark Smoke. No dark smoke on this shield -> original order, opens on the cheapest option. */
        var isDark = function (v) { return /\bd(?:a)?r?k\.?\s*sm(?:o)?k/i.test(v.title); };
        var vs = sh.variants.filter(isDark).concat(sh.variants.filter(function (v) { return !isDark(v); }));
        var def = isDark(vs[0]) ? vs[0] : vs.reduce(function (a, v) { return v.price < a.price ? v : a; }, vs[0]);
        var opts = vs.map(function (v) {
          return '<option value="' + v.id + '"' + (v === def ? ' selected' : '') + '>' + escapeHtml(v.title) + ' · ' + formatMoney(v.price) + '</option>';
        }).join('');
        var pic = def.image || sh.image;
        var el = document.createElement('div');
        el.className = 'cupsell';
        el.innerHTML =
          '<a class="cu-pic" href="' + escapeHtml(sh.url) + '">' + (pic ? '<img src="' + escapeHtml(pic) + '" alt="">' : '') + '</a>' +
          '<div class="cu-info">' +
            '<div class="cu-k">Add the matching shield</div>' +
            '<div class="cu-row">' +
              (many ? '<select class="cu-sel" aria-label="Shield option">' + opts + '</select>'
                    : '<span class="cu-pr">' + formatMoney(def.price) + '</span>') +
              '<button type="button" class="cu-add">+ Add</button>' +
            '</div>' +
          '</div>';
        var selEl = el.querySelector('.cu-sel');
        if (selEl) selEl.addEventListener('change', function () {
          var v = sh.variants.filter(function (x) { return String(x.id) === selEl.value; })[0];
          var im = el.querySelector('.cu-pic img');
          if (v && v.image && im) im.src = v.image;
        });
        el.querySelector('.cu-add').addEventListener('click', function () {
          var sel = el.querySelector('.cu-sel');
          window.addToCart(sel ? sel.value : def.id, sh.title, 1);
        });
        row.parentNode.insertBefore(el, row.nextSibling);
      });
    });
  }

  window.toggleCart = function (open) {
    var d = document.getElementById('drawer');
    var o = document.getElementById('overlay');
    if (d) d.classList.toggle('open', open);
    if (o) o.classList.toggle('open', open);
    lockBody('cart', open);
    if (open) renderCart();
  };

  function initials(b) {
    if (!b) return '';
    var w = b.trim().split(/\s+/);
    return (w.length > 1 ? w[0][0] + w[1][0] : b.slice(0, 2)).toUpperCase();
  }
  function escapeHtml(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- command palette (Predictive Search) ---------- */
  var palSel = 0, palTimer;
  window.openPalette = function () {
    closeMega();
    document.getElementById('overlay').classList.add('open');
    document.getElementById('palette').classList.add('open');
    lockBody('palette', true);
    var inp = document.getElementById('palInput');
    inp.value = '';
    renderPalette();
    try { inp.focus(); } catch (e) {}                 // synchronous focus keeps the iOS keyboard in the tap gesture
    setTimeout(function () { try { inp.focus(); } catch (e) {} }, 60);  // fallback for late layout
  };
  window.closePalette = function () {
    var p = document.getElementById('palette');
    if (p) p.classList.remove('open');
    var o = document.getElementById('overlay');
    if (o && !document.getElementById('drawer').classList.contains('open')) o.classList.remove('open');
    lockBody('palette', false);
  };

  window.renderPalette = function () {
    var q = (document.getElementById('palInput').value || '').trim();
    var body = document.getElementById('palBody');
    if (!q) {
      body.innerHTML = '<div class="pal-empty">Start typing to search parts, brands and pages…</div>';
      return;
    }
    clearTimeout(palTimer);
    palTimer = setTimeout(function () {
      var url = (routes.predictive_search_url || '/search/suggest') +
        '.json?q=' + encodeURIComponent(q) +
        /* limit_scope=each gives products their OWN 6 slots. Without it the budget of 6 was
           shared across pages+collections+products, so a query like "helmet" spent its slots
           on a buying guide and two collections and returned 3 accessories, zero helmets.
           Audited 2026-08-06. */
        '&resources[type]=product,collection,page&resources[limit]=6&resources[limit_scope]=each';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = (data.resources && data.resources.results) || {};
          var html = '';
          if (res.pages && res.pages.length) {
            html += '<div class="pal-group">Pages</div>';
            html += res.pages.map(function (p) {
              return '<a class="pal-item" href="' + p.url + '"><div class="pic">📄</div><div class="meta"><div class="t">' + escapeHtml(p.title) + '</div><div class="s">Page</div></div><span class="chev">↵</span></a>';
            }).join('');
          }
          if (res.collections && res.collections.length) {
            html += '<div class="pal-group">Collections</div>';
            html += res.collections.map(function (c) {
              return '<a class="pal-item" href="' + c.url + '"><div class="pic">🗂️</div><div class="meta"><div class="t">' + escapeHtml(c.title) + '</div><div class="s">Collection</div></div><span class="chev">↵</span></a>';
            }).join('');
          }
          if (res.products && res.products.length) {
            html += '<div class="pal-group">Parts</div>';
            html += res.products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:9px">' : (p.vendor ? initials(p.vendor) : '🏍️');
              var price = (p.price_min != null) ? formatMoney(p.price_min) : '';
              return '<a class="pal-item" href="' + p.url + '"><div class="pic">' + img + '</div><div class="meta"><div class="t">' + escapeHtml(p.title) + '</div><div class="s">' + escapeHtml(p.vendor || '') + '</div></div><span class="price">' + price + '</span></a>';
            }).join('');
          }
          if (!html) html = '<div class="pal-empty">No matches for “' + escapeHtml(q) + '”.</div>';
          body.innerHTML = html;
          /* palSel = -1 means "nothing chosen". Previously this was 0, which pre-selected the
             first suggestion after every keystroke, so pressing Enter hijacked the customer to
             whatever sat at the top (usually a CMS page) and the real search results page was
             unreachable from the header. Audited 2026-08-06. */
          palSel = -1; highlight();
        })
        .catch(function () { body.innerHTML = '<div class="pal-empty">Search is unavailable right now.</div>'; });
    }, 180);
  };

  function highlight() {
    var items = [].slice.call(document.querySelectorAll('.pal-item'));
    items.forEach(function (it, i) { it.classList.toggle('sel', palSel >= 0 && i === palSel); });
  }
  window.palKey = function (e) {
    var items = [].slice.call(document.querySelectorAll('.pal-item'));
    if (e.key === 'ArrowDown') { e.preventDefault(); palSel = Math.min(palSel + 1, items.length - 1); highlight(); if (items[palSel]) items[palSel].scrollIntoView({ block: 'nearest' }); }
    if (e.key === 'ArrowUp') { e.preventDefault(); palSel = Math.max(palSel - 1, -1); highlight(); if (palSel >= 0 && items[palSel]) items[palSel].scrollIntoView({ block: 'nearest' }); }
    /* Enter only follows a suggestion the customer actually arrowed onto. Otherwise it falls
       through to the native form submit and lands on the full search results page. */
    if (e.key === 'Enter') { if (palSel >= 0 && items[palSel]) { e.preventDefault(); window.location.href = items[palSel].getAttribute('href'); } }
  };

  /* ---------- global keys ---------- */
  window.addEventListener('keydown', function (e) {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); openPalette(); }
    if (e.key === 'Escape') { closePalette(); toggleCart(false); closeMega(); }
  });

  /* ---------- product page (PDP) ---------- */
  window.rdThumb = function (btn, src) {
    var main = document.getElementById('gmain');
    if (main) { main.removeAttribute('srcset'); main.src = src; }
    var p = btn.parentNode;
    p.querySelectorAll('button').forEach(function (b) { b.classList.remove('act'); });
    btn.classList.add('act');
    /* thumbnail-to-variant sync: match the clicked photo to the variant that owns it
       (by filename, CDN hosts differ), then select its color via rdPick so price,
       SKU, stock line and add-to-cart all follow. Size/other matching options kept. */
    try {
      if (!window.rdProduct) return;
      var fname = function (u) { return (u || '').split('?')[0].split('/').pop(); };
      var base = fname(src);
      var owners = window.rdProduct.variants.filter(function (x) {
        return x.featured_image && fname(x.featured_image.src) === base;
      });
      if (!owners.length) return;
      var chosen = rdChosen();
      var v = owners.slice().sort(function (a, b) {
        function score(x) {
          var s = 0;
          x.options.forEach(function (o, i) { if (o === chosen[i]) s++; });
          if (x.available) s += 0.5;
          return s;
        }
        return score(b) - score(a);
      })[0];
      [].slice.call(document.querySelectorAll('.opt .seg')).forEach(function (seg) {
        var idx = parseInt(seg.dataset.optIndex, 10);
        var val = v.options[idx];
        var act = seg.querySelector('button.act');
        if (act && act.dataset.value === val) return;
        var target = null;
        seg.querySelectorAll('button').forEach(function (b) { if (!target && b.dataset.value === val) target = b; });
        if (target) rdPick(target);
      });
    } catch (e) {}
  };

  /* manufacturer video: swap the facade thumbnail for the embed on click */
  window.rdPlayYT = function (el) {
    var id = el && el.dataset ? el.dataset.yt : '';
    if (!id) return;
    el.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" title="Product video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    el.classList.add('playing');
  };

  function rdCurrentVariant() {
    if (!window.rdProduct) return null;
    var segs = [].slice.call(document.querySelectorAll('.opt .seg'));
    if (!segs.length) return window.rdProduct.variants[0];
    var chosen = [];
    segs.forEach(function (seg) {
      var idx = parseInt(seg.dataset.optIndex, 10);
      var act = seg.querySelector('button.act');
      chosen[idx] = act ? act.dataset.value : null;
    });
    return window.rdProduct.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    }) || null;
  }

  /* Per-variant stock state, injected by main-product.liquid from snippets/stock-state.
     States: low | instock | backorder | oos. Single source of truth, the JS never
     re-derives availability, it just reads the state the server already resolved. */
  function vState(v) {
    var s = (window.rdStock && v) ? window.rdStock[v.id] : null;
    if (s && s.s) return s.s;
    return (v && v.available) ? 'instock' : 'oos';   // fallback if the map is missing
  }
  function vQty(v) {
    var s = (window.rdStock && v) ? window.rdStock[v.id] : null;
    return s ? s.q : undefined;
  }
  function rdStockLabel(kind, priceCents) {
    var L = window.rdStockLabels || {};
    if (kind === 'backorder') return L.backorder || 'Ships in 5 days';
    /* free-shipping wording only when the item itself clears the $150 threshold */
    if (typeof priceCents === 'number' && priceCents < 15000) return 'Ships in 24 hrs';
    return L.instock || 'Free Shipping in 24 hrs';
  }
  function rdPhysStock() {
    if (!window.rdStock || !window.rdProduct) return false;
    return window.rdProduct.variants.some(function (v) { var s = vState(v); return s === 'instock' || s === 'low'; });
  }
  function rdRefresh() {
    var v = rdCurrentVariant();
    var qEl = document.getElementById('q');
    var qty = qEl ? parseInt(qEl.textContent, 10) : 1;
    var add = document.getElementById('pdpAdd');
    if (v) {
      /* One state decides everything: the stock line, the button label and orderability.
         Note orderability comes from the STATE, not from v.available, a variant left on
         CONTINUE with no stock and no Backorderable flag must not be addable to cart. */
      var st = vState(v);
      var orderable = st !== 'oos';
      if (add) { add.dataset.variantId = v.id; add.disabled = !orderable; add.style.opacity = orderable ? '' : '.5'; }
      /* the sticky bottom bar must tell the same truth as the main button */
      var sadd = document.querySelector('#sticky .addbtn');
      if (sadd) { sadd.disabled = !orderable; sadd.style.opacity = orderable ? '' : '.5'; sadd.dataset.need = ''; sadd.classList.remove('need'); }

      var stockEl = document.getElementById('stockLine');
      if (stockEl) {
        if (st === 'low') stockEl.innerHTML = '<span class="s1 low"><i></i> Only ' + (vQty(v) || 1) + ' left · ready to ship</span>';
        else if (st === 'instock') stockEl.innerHTML = '<span class="s1"><i></i> ' + rdStockLabel('instock', (typeof v.p === 'number' ? v.p : v.price)) + '</span>';
        else if (st === 'backorder') stockEl.innerHTML = '<span class="s1 mto"><i></i> ' + rdStockLabel('backorder') + '</span>';
        else stockEl.innerHTML = '<span class="s1" style="color:var(--mute)">Out of stock</span>';
      }
      var guarEl = document.getElementById('stockGuar');
      if (guarEl) guarEl.style.display = (st === 'instock' || st === 'low') ? '' : 'none';   // the $300 promise only while the page says in stock
      var noteEl = document.getElementById('mtoNote');
      if (noteEl) noteEl.style.display = (st === 'backorder') ? '' : 'none';
      var lbl = add ? add.querySelector('.add-label') : null;
      if (lbl) lbl.textContent = orderable ? 'Add to cart' : 'Out of stock';
      var price = document.getElementById('price'); if (price) price.textContent = formatMoney(v.price);
      // sale strikethrough + discount badge follow the selected variant
      var _pc = document.getElementById('priceCompare'), _db = document.getElementById('discBadge'), _cap = v.compare_at_price || 0;
      if (_cap > v.price) {
        if (_pc) { _pc.textContent = formatMoney(_cap); _pc.style.display = ''; }
        if (_db) { _db.textContent = rdDiscLabel(_cap, v.price); _db.style.display = ''; }
      } else {
        if (_pc) _pc.style.display = 'none';
        if (_db) _db.style.display = 'none';
      }
      var addP = document.getElementById('addPrice'); if (addP) addP.textContent = formatMoney(v.price * qty);
      var sp = document.getElementById('sp'); if (sp) sp.textContent = formatMoney(v.price); var spc = document.getElementById('spc'); if (spc) { if (_cap > v.price) { spc.textContent = formatMoney(_cap); spc.hidden = false; } else spc.hidden = true; } var sPic = document.querySelector('#sticky .pic img'); if (sPic && v.featured_image && v.featured_image.src) { sPic.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120'; } /* 2026-09-30 sticky bar photo follows the chosen colour (Abi: Abbes white showed a black thumb) */
      var skuEl = document.getElementById('pdpSku'); if (skuEl && v.sku) skuEl.textContent = 'SKU: ' + v.sku;
      var ssEl = document.getElementById('specSku'); if (ssEl && v.sku) ssEl.textContent = v.sku;
      var pb = document.getElementById('pickupBox'); if (pb && window.rdPickup) { pb.classList.toggle('on', !!window.rdPickup[v.id]); }
      if (v.featured_image && v.featured_image.src) {
        var gm = document.getElementById('gmain'); if (gm) { gm.removeAttribute('srcset'); gm.src = v.featured_image.src; }
        var base = imgBase(v.featured_image.src);
        var thumbs = document.querySelectorAll('#gthumbs button');
        thumbs.forEach(function (b) {
          var im = b.querySelector('img');
          var match = im && imgBase(im.getAttribute('src')) === base;
          b.classList.toggle('act', match);
          if (match) try { b.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) {}
        });
      }
    } else if (add) {
      add.disabled = true; add.style.opacity = '.5';
      var _ch = rdChosen(), _need = _ch.some(function (c) { return c == null; });
      var _l0 = add.querySelector('.add-label'); if (_l0) _l0.textContent = _need ? 'Select a size' : 'Unavailable';
      var _sa = document.querySelector('#sticky .addbtn'); if (_sa) { _sa.disabled = !_need; _sa.dataset.need = _need ? '1' : ''; _sa.style.opacity = _need ? '' : '.5'; _sa.classList.toggle('need', _need); }
      if (_need && window.rdProduct) {
        /* colour-level stock line while no size is picked: best state across that colour's sizes */
        var _vs = window.rdProduct.variants.filter(function (vv) { return vv.options.every(function (o, i) { return _ch[i] == null || o === _ch[i]; }); });
        var _st = _vs.map(vState), _se = document.getElementById('stockLine');
        if (_se) {
          if (_st.indexOf('instock') >= 0 || _st.indexOf('low') >= 0) _se.innerHTML = '<span class="s1"><i></i> ' + rdStockLabel('instock', _vs[0] && _vs[0].price) + '</span>';
          else if (_st.indexOf('backorder') >= 0) _se.innerHTML = '<span class="s1 mto"><i></i> ' + rdStockLabel('backorder') + '</span>';
          else _se.innerHTML = '<span class="s1" style="color:var(--mute)">Out of stock</span>';
        }
      }
    }
    var _ci = window.rdProduct ? window.rdProduct.colorIndex : -1;
    var col = (_ci >= 0) ? ((v && v.options) ? v.options[_ci] : (rdChosen()[_ci] || null)) : null;
    rdFilterGallery(col);
    rdMarkNA();
  }
  function rdFilterGallery(color){
    var box = document.getElementById('gthumbs'); if(!box) return;
    var thumbs = [].slice.call(box.querySelectorAll('button'));
    var anyColor = thumbs.some(function(b){ return b.dataset.color; });
    if(!color || !anyColor){ thumbs.forEach(function(b){ b.style.display=''; }); return; }
    var visible = 0, matchBtn = null;
    thumbs.forEach(function(b){
      var show = !b.dataset.color || b.dataset.color === color;
      b.style.display = show ? '' : 'none';
      if(show) visible++;
      if(b.dataset.color === color && !matchBtn) matchBtn = b;
    });
    if(!visible) thumbs.forEach(function(b){ b.style.display = b.dataset.color ? 'none' : ''; }); // color owns no photos: show ONLY generic shots, never other colors'
    // Sync the main image to the selected color's own photo (thumbnails are correctly color-tagged)
    if(matchBtn){
      var full = matchBtn.getAttribute('data-full');
      var gm = document.getElementById('gmain');
      if(full && gm){ gm.removeAttribute('srcset'); gm.src = full; }
      thumbs.forEach(function(b){ b.classList.toggle('act', b===matchBtn); });
    } else {
      // selected color has no own photo: point hero at the first visible (generic) thumb, never leave it on another color
      var firstVis = thumbs.filter(function(b){ return b.style.display !== 'none'; })[0];
      var gm2 = document.getElementById('gmain');
      if(firstVis && gm2){ var f2 = firstVis.getAttribute('data-full'); if(f2){ gm2.removeAttribute('srcset'); gm2.src = f2; } }
      thumbs.forEach(function(b){ b.classList.toggle('act', b===firstVis); });
    }
  }
  function imgBase(u) { return (u || '').split('?')[0]; }

  function rdChosen() {
    var chosen = [];
    [].slice.call(document.querySelectorAll('.opt .seg')).forEach(function (seg) {
      var act = seg.querySelector('button.act');
      chosen[parseInt(seg.dataset.optIndex, 10)] = act ? act.dataset.value : null;
    });
    return chosen;
  }
  /* if the picked combo doesn't exist, keep the value just picked and
     auto-switch the other option(s) to the closest real variant */
  function rdResolve(changedSeg) {
    if (!window.rdProduct) return;
    var segs = [].slice.call(document.querySelectorAll('.opt .seg'));
    if (segs.length < 2) return;
    var chosen = rdChosen();
    if (chosen.some(function (c) { return c == null; })) return;   // an option not chosen yet (size on load): nothing to resolve
    var exists = window.rdProduct.variants.some(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });
    if (exists) return;
    var keepIdx = parseInt(changedSeg.dataset.optIndex, 10);
    var keepVal = chosen[keepIdx];
    var cands = window.rdProduct.variants.filter(function (v) { return v.options[keepIdx] === keepVal; });
    if (!cands.length) return;
    var pick = cands.find(function (v) { return v.available; }) || cands[0];
    segs.forEach(function (seg) {
      var idx = parseInt(seg.dataset.optIndex, 10);
      if (idx === keepIdx) return;
      seg.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('act', b.dataset.value === pick.options[idx]);
      });
      var span = document.getElementById(seg.dataset.valspan);
      if (span) span.textContent = pick.options[idx];
    });
  }
  /* dim option values that don't exist (or are sold out) with the current other selections */
  function rdMarkNA() {
    if (!window.rdProduct) return;
    var segs = [].slice.call(document.querySelectorAll('.opt .seg'));
    if (!segs.length) return;
    var phys = rdPhysStock();
    var chosen = rdChosen();
    segs.forEach(function (seg) {
      var idx = parseInt(seg.dataset.optIndex, 10);
      seg.querySelectorAll('button').forEach(function (b) {
        /* with a size unpicked several variants match: judge them all, not the first (Abi 2026-11-01) */
        var ms = window.rdProduct.variants.filter(function (vv) {
          return vv.options.every(function (o, i) { return i === idx ? o === b.dataset.value : (chosen[i] == null || o === chosen[i]); });
        });
        var av = ms.filter(function (vv) { return vv.available; });
        b.classList.toggle('na', !ms.length);
        b.classList.toggle('oos', !!ms.length && !av.length);
        b.classList.toggle('bo', phys && !!av.length && av.every(function (vv) { var q2 = vQty(vv); return typeof q2 === 'number' && q2 <= 0; }));
      });
    });
  }
  window.rdPick = function (btn) {
    var seg = btn.closest('.seg');
    seg.querySelectorAll('button').forEach(function (b) { b.classList.remove('act'); });
    btn.classList.add('act');
    var span = document.getElementById(seg.dataset.valspan);
    /* show the friendly color name when one exists; data-value stays the raw
       option value (SKU/gallery matching depends on it) */
    if (span) span.textContent = btn.dataset.label || btn.dataset.value;
    rdResolve(seg);
    rdRefresh();
  };

  window.rdQty = function (d) {
    var qEl = document.getElementById('q');
    if (!qEl) return;
    var q = Math.max(1, parseInt(qEl.textContent, 10) + d);
    qEl.textContent = q;
    rdRefresh();
  };

  // sticky add bar on scroll (only on product page)
  if (document.getElementById('sticky')) {
    var rdBarMq = window.matchMedia('(max-width: 749px)'), rdBarAdd = document.getElementById('pdpAdd');
    /* MOCKUP v3 2026-10-02 (Abi): on phones the bar appears once the inline Add to cart is fully off the top
       and leaves only once it is back at least 40px into view. The 40px gap plus an 80ms settle stops the
       bar flickering when a shopper stops scrolling right at the button. */
    if (rdBarAdd) {
      var rdBarOn = false, rdBarT = null, rdBarRaf = 0;
      var rdBarSet = function (on) {
        document.getElementById('sticky').classList.toggle('show', on);
        document.body.classList.toggle('rd-sticky-on', on);
      };
      var rdBarCheck = function () {
        rdBarRaf = 0; if (!rdBarMq.matches) return;
        var b = rdBarAdd.getBoundingClientRect().bottom, want = rdBarOn;
        if (!rdBarOn && b < 0) want = true;          /* fully scrolled off the top */
        else if (rdBarOn && b > 40) want = false;    /* back at least 40px into view */
        if (want === rdBarOn) { clearTimeout(rdBarT); rdBarT = null; return; }
        if (rdBarT) return;
        rdBarT = setTimeout(function () { rdBarT = null; var bb = rdBarAdd.getBoundingClientRect().bottom;
          var w = rdBarOn ? !(bb > 40) : bb < 0; if (w !== rdBarOn) { rdBarOn = w; rdBarSet(w); } }, 80);
      };
      window.addEventListener('scroll', function () { if (!rdBarRaf) rdBarRaf = requestAnimationFrame(rdBarCheck); }, { passive: true });
      window.addEventListener('resize', function () { if (!rdBarRaf) rdBarRaf = requestAnimationFrame(rdBarCheck); });
      rdBarCheck();
    }
    window.addEventListener('scroll', function () {
      if (rdBarAdd && rdBarMq.matches) return;
      var stickyOn = window.scrollY > 640;
      document.getElementById('sticky').classList.toggle('show', stickyOn);
      document.body.classList.toggle('rd-sticky-on', stickyOn);
    });
  }

  /* ---------- recently viewed ---------- */
  window.rvStore = function (p) {
    try {
      var a = JSON.parse(localStorage.getItem('rd_recent') || '[]');
      a = a.filter(function (x) { return x.handle !== p.handle; });
      a.unshift(p);
      localStorage.setItem('rd_recent', JSON.stringify(a.slice(0, 10)));
    } catch (e) {}
  };
  function rvRender() {
    var host = document.getElementById('recentlyViewed');
    if (!host) return;
    var rail = document.getElementById('rvRail');
    var cur = host.dataset.current || '';
    var a = [];
    try { a = JSON.parse(localStorage.getItem('rd_recent') || '[]'); } catch (e) {}
    a = a.filter(function (x) { return x.handle && x.handle !== cur; }).slice(0, 8);
    if (a.length < 2) { host.style.display = 'none'; return; }
    rail.innerHTML = a.map(function (p) {
      var img = p.image ? '<img class="pimg" src="' + p.image + '" alt="">' : '<span class="ph"><b>' + escapeHtml(p.vendor || '') + '</b></span>';
      return '<a class="card" href="' + p.url + '"><span class="visual' + (p.image ? '' : ' noimg') + '" style="display:block">' + img + '</span>' +
        '<h3>' + escapeHtml(p.title) + '</h3><div class="brand">' + escapeHtml(p.vendor || '') + '</div>' +
        '<div class="foot"><div class="price">' + escapeHtml(p.price || '') + '</div></div></a>';
    }).join('');
    host.style.display = '';
  }

  /* ---------- before/after compare slider ---------- */
  (function initCompare() {
    var c = document.getElementById('compare');
    if (!c) return;
    var after = document.getElementById('cmpAfter');
    var div = document.getElementById('cmpDivider');
    function set(clientX) {
      var r = c.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (clientX - r.left) / r.width));
      after.style.clipPath = 'inset(0 ' + (100 - p * 100) + '% 0 0)';
      div.style.left = (p * 100) + '%';
    }
    after.style.clipPath = 'inset(0 50% 0 0)';
    var drag = false;
    c.addEventListener('pointerdown', function (e) { drag = true; set(e.clientX); e.preventDefault(); });
    window.addEventListener('pointermove', function (e) { if (drag) set(e.clientX); });
    window.addEventListener('pointerup', function () { drag = false; });
  })();

  /* ---------- init ---------- */
  renderCart();
  rvRender();
  if (document.querySelector('.opt .seg')) { try { rdMarkNA(); } catch (e) {} }
})();

  /* ---------- color swatches + initial gallery filter ---------- */
  (function(){
    var seg = document.querySelector('.seg--color');
    if(seg){
      var MAP={'red fluo':'#ff2d2d','yellow fluo':'#e8ff00','black':'#141414','white':'#f4f4f4','red':'#d0342c','blue':'#2563eb','navy':'#1e2a52','yellow':'#f5c518','gray':'#8a8a8a','grey':'#8a8a8a','green':'#16a34a','orange':'#f2660a','pink':'#ec4899','silver':'#c4c4c4','gold':'#d4af37','teak':'#8b5a2b','indigo':'#4b0082','aluminum':'#b0b4b8','fluo':'#c6ff00','brown':'#6b4423','tan':'#d2b48c','camo':'#78866b','anthracite':'#3a3a3a'};
      function hex(w){ w=(w||'').toLowerCase(); for(var k in MAP){ if(w.indexOf(k)>=0) return MAP[k]; } return null; }
      seg.querySelectorAll('button').forEach(function(b){
        if(b.querySelector('.swatch-dot')) return;
        var parts=(b.dataset.value||'').split('/').map(function(s){return s.trim();});
        var c1=hex(parts[0])||'#cfcfcf'; var c2=parts[1]?(hex(parts[1])||c1):c1;
        var dot=document.createElement('span'); dot.className='swatch-dot';
        dot.style.background = (c1===c2)? c1 : ('linear-gradient(135deg,'+c1+' 0 50%,'+c2+' 50% 100%)');
        b.insertBefore(dot,b.firstChild);
      });
    }
    if(document.getElementById('gthumbs') && typeof rdRefresh==='function'){ try{ rdRefresh(); }catch(e){} }
  })();

  /* rd-alt: "Check these out instead" on dead product pages. Shows ONLY when every
     variant reads oos from rdStock (the server-resolved truth). Pulls Shopify's native
     recommendations, keeps in-stock ones, renders up to 4 simple cards. */
  (function () {
    var box = document.getElementById('rdAlt');
    if (!box || !window.rdStock || !window.rdProduct) return;
    var allDead = window.rdProduct.variants.every(function (v) {
      var s = window.rdStock[v.id]; return !s || s.s === 'oos';
    });
    if (!allDead) return;
    fetch('/recommendations/products.json?product_id=' + box.dataset.pid + '&limit=8')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var picks = (d.products || []).filter(function (p) { return p.available; }).slice(0, 8);
        if (!picks.length) return;               // nothing worth showing, stay hidden
        var grid = document.getElementById('rdAltGrid');
        grid.innerHTML = picks.map(function (p) {
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
          return '<a class="rd-alt-card" href="' + p.url + '">'
            + (img ? '<span class="rd-alt-imgwrap"><img loading="lazy" src="' + img + '" alt=""></span>' : '')
            + '<span class="rd-alt-t">' + p.title + '</span>'
            + '<span class="rd-alt-p">$' + (p.price / 100).toFixed(2) + '</span></a>';
        }).join('');
        box.hidden = false;
      })
      .catch(function () { /* recommendations unavailable, page stays as-is */ });
  })();

  /* gmain-swipe REMOVED 2026-09-30 (mobile audit #3): a second touch handler here clicked the next thumb
     while the inline rf-mob swipe in main-product.liquid also advanced, so every swipe skipped a photo
     (dots 0,2,4,6). The rf-mob handler is on every product and is the only one now. */

  /* rd-size-sort: order Size option buttons logically.
     Handles three families, because the catalogue genuinely uses all three:
       lettered  XS..4XL, written either short (XL) or long (X-LARGE)
       numeric   EU jacket 48-60, EU boot 39-49, waist 28-38
     Fixed 2026-08-07: hyphens were not stripped, so "X-LARGE" never matched and the
     0.6 confidence check bailed out, leaving apparel in creation order; and numeric
     size runs were never sorted at all (an Alpinestars jacket rendered 48,52,54,58,50,56,60). */
  (function(){
    var ORDER=['XXS','2XS','XSMALL','XS','SMALL','SM','S','MEDIUM','MD','M','LARGE','LG','L',
               'XLARGE','XL','XXLARGE','2XLARGE','2XL','XXL','XXXLARGE','3XLARGE','3XL','XXXL',
               '4XLARGE','4XL','XXXXL','5XLARGE','5XL'];
    function key(v){ return (v||'').toUpperCase().replace(/[\s.\-_]/g,''); }
    function rank(v){ var i=ORDER.indexOf(key(v)); return i<0?999:i; }
    function num(v){ var m=(v||'').match(/^\s*(\d+(?:\.\d+)?)\s*$/); return m?parseFloat(m[1]):null; }
    [].slice.call(document.querySelectorAll('.opt')).forEach(function(opt){
      var lab=opt.querySelector('.lab'); if(!lab||!/size/i.test(lab.textContent)) return;
      var seg=opt.querySelector('.seg'); if(!seg) return;
      var btns=[].slice.call(seg.querySelectorAll('button')); if(btns.length<3) return;
      var numeric=btns.filter(function(b){return num(b.dataset.value)!==null;}).length;
      if(numeric===btns.length){                       /* pure numeric run: sort ascending */
        btns.sort(function(a,b){return num(a.dataset.value)-num(b.dataset.value);});
      } else {
        var sizeish=btns.filter(function(b){return rank(b.dataset.value)<999;}).length;
        if(sizeish < btns.length*0.6) return;          /* not a size run we understand */
        btns.sort(function(a,b){return rank(a.dataset.value)-rank(b.dataset.value);});
      }
      btns.forEach(function(b){seg.appendChild(b);});
    });
  })();

/* 2026-09-30 sticky add bar photo mirrors the main gallery photo (Abi: RPHA 91 Abbes white/blue showed a black
   thumbnail). The gallery already switches on colour alone, before a size is picked; the bar follows it. */
(function rdStickyPicSync(){
  function run(){
    var main = document.getElementById('gmain'), pic = document.querySelector('#sticky .pic img');
    if (!main || !pic) return;
    function sync(){ var s = main.getAttribute('src'); if (!s) return;   /* the attribute, not currentSrc: currentSrc lags until the new image loads */
      pic.src = s.replace(/([?&])width=\d+/, '$1width=120'); }
    new MutationObserver(sync).observe(main, { attributes: true, attributeFilter: ['src', 'srcset'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();


/* MOCKUP 2026-10-02: chat box in the mobile sticky bar. Un-hides the Shopify Inbox host, then opens it. */
/* 2026-10-02 mockup: chat box in the mobile sticky bar. The floating Inbox pill is hidden on mobile; we show
   the host only while the panel is open. Inbox sets an `open` attribute on <shopify-chat> while the panel is up
   (measured 2026-10-02), so when it goes away we hide the host again and the pill does not come back. */
window.rdBarChat = function () {
  var root = document.documentElement; root.classList.add('rd-chat-on');
  /* open AFTER this tap finishes: opening inside the click let Inbox read the same click as
     'outside the panel' and close itself 26ms later on a second open (measured 2026-10-02) */
  setTimeout(function () { if (window.rdOpenChat) window.rdOpenChat(); }, 60);
  var tries = 0, iv = setInterval(function () {
    var h = document.querySelector('shopify-chat,#shopify-chat');
    if (!h && ++tries < 40) return; clearInterval(iv); if (!h) return;
    if (h._rdObs) return;
    var seen = false;
    h._rdObs = new MutationObserver(function () {
      if (h.hasAttribute('open')) seen = true;
      else if (seen) { root.classList.remove('rd-chat-on'); seen = false; }
    });
    h._rdObs.observe(h, { attributes: true, attributeFilter: ['open'] });
    if (h.hasAttribute('open')) seen = true;
  }, 250);
};
/* grey sticky Add (no size picked yet): tap scrolls to the first unpicked option and flashes it */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('#sticky .addbtn');
  if (!b || b.dataset.need !== '1') return;
  e.preventDefault(); e.stopPropagation();
  /* first option with nothing picked, same test rdChosen() uses (a .seg with no button.act) */
  var seg = [].slice.call(document.querySelectorAll('.opt .seg')).filter(function (s) { return !s.querySelector('button.act'); })[0];
  var box = seg ? (seg.closest('.opt') || seg) : null;
  if (!box) return;
  var r = box.getBoundingClientRect();
  window.scrollTo({ top: Math.max(0, window.scrollY + r.top - (window.innerHeight - r.height) / 2), behavior: 'smooth' });
  box.classList.remove('rd-flash'); void box.offsetWidth; box.classList.add('rd-flash');
}, true);

